module.exports = __webpack_public_path__ + "media/images/redesign-images/careers/art/gallery/art-gallery-04-037b7ed82fea017d4c4327563b891ed7.jpg";